import * as React from 'react';
import { Dispatch } from 'react-redux';
import { Translate, I18n } from 'react-redux-i18n';

import { StoreState } from '../../reducers';
import Popup from '../Popup';
import { PopupBodyWrapper, Button } from './styles';
import { Api } from '../../typings/api';
import { shareProposalByEmail } from '../../containers/ShareProposal/actions';
import { share } from '../../containers/Share/actions';
import { StyleColor } from '../../utils/styles-constants';

interface ShareProposalProps {
	clientId: number;
	resourceId: number;
	label: string;
	driveItem: Api.DriveItem;
	isDisplayed: boolean;
	onCancel: () => void;
	dispatch: Dispatch<StoreState>;
}

const ShareProposal = ({
	clientId,
	resourceId,
	label,
	driveItem,
	isDisplayed,
	onCancel,
	dispatch,
}: ShareProposalProps) => {
	const handleSendByEmailClick = () => dispatch(shareProposalByEmail(clientId, resourceId, label));
	const handleSendViaUprezClick = () => {
		dispatch(share([driveItem], true));
		onCancel();
	};

	return (
		<Popup
			isDisplayed={isDisplayed}
			label={I18n.t('messages.send_my_proposal')}
			onCancel={onCancel}
			actionButtonColor={StyleColor.Blue600}
		>
			<PopupBodyWrapper>
				<Button
					type="button"
					onClick={handleSendByEmailClick}
				>
					<Translate value="messages.send_by_email" />
				</Button>
				<Button
					type="button"
					onClick={handleSendViaUprezClick}
				>
					<Translate value="messages.send_via_uprez" />
				</Button>
			</PopupBodyWrapper>
		</Popup>
	);
};

export default ShareProposal;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ShareProposal/index.tsx